<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Detail Action Step">
            <br>
            <common-training-header :withUser="false"/>
        </a-page-header>

        <div class="text-right" style="margin-bottom: 24px">
            <a-button type="primary" icon="plus" @click="showModal('')"> Tambah</a-button>
        </div>

        <a-card type="inner" size="small">

            <a-skeleton :loading="loading" active>
                <a-table
                    class="pcp-table"
                    :columns="columns"
                    :dataSource="data.steps"
                    rowKey="id"
                    :pagination="false"
                    :rowClassName="(r) => r.is_approved ? 'border-success' : 'border-warning'"
                >

                    <div slot="step" slot-scope="record" style="text-align: left">
                        {{ record.title }}
                    </div>

                    <div slot="start" slot-scope="record" style="text-align: left">
                        {{ moment(record.plan_date_start).format('DD MMMM YYYY') }}
                    </div>

                    <div slot="done" slot-scope="record" style="text-align: left">
                        {{ moment(record.plan_date_end).format('DD MMMM YYYY') }}
                    </div>

                    <div slot="exe_date" slot-scope="record" style="text-align: left">
                        <div v-if="record.actual_date_end != null && record.status == 'done'">
                            {{ moment(record.actual_date_end).format('DD MMMM YYYY') }}
                        </div>
                    </div>

                    <div slot="gap" slot-scope="record">
                        <div v-if="record.actual_date_end != null && record.status == 'done'">
                            <a-tag color="#53ff4a" v-if="moment(record.actual_date_end, 'YYYY-MM-DD').diff(moment(record.plan_date_end, 'YYYY-MM-DD'), 'days') < 0">
                                <div style="color:black;width:20px">
                                    <strong>{{ moment(record.plan_date_end, 'YYYY-MM-DD').diff(moment(record.actual_date_end, 'YYYY-MM-DD'), 'days') }}</strong>
                                </div>
                            </a-tag>
                            <a-tag color="#f2eb18" v-else-if="moment(record.actual_date_end, 'YYYY-MM-DD').diff(moment(record.plan_date_end, 'YYYY-MM-DD'), 'days') == 0">
                                <div style="color:black;width:20px">
                                    <strong>{{ moment(record.actual_date_end, 'YYYY-MM-DD').diff(moment(record.plan_date_end, 'YYYY-MM-DD'), 'days') }}</strong>
                                </div>
                            </a-tag>
                            <a-tag color="#ff0000" v-else>
                                <div style="width:20px">
                                    <strong>{{ moment(record.actual_date_end, 'YYYY-MM-DD').diff(moment(record.plan_date_end, 'YYYY-MM-DD'), 'days') }}</strong>
                                </div>
                            </a-tag>
                        </div>
                    </div>

                    <div slot="progress" slot-scope="record">
                        {{ progress[record.status] }}
                    </div>

                    <div slot="percent" slot-scope="record" :style="'background-color: ' + prgColor(record.progress) ">
                        {{ record.progress }} %
                    </div>

                    <div slot="pic" slot-scope="record">
                        {{ record.pic }}
                    </div>

                    <div slot="photo" slot-scope="record">
                        <a-tooltip title="Upload Foto">
                            <a-button
                                size="small"
                                type="primary"
                                icon="upload"
                                @click="showModalUpload('photo', record.id)"
                            />
                        </a-tooltip>
                        <template v-for="item in record.files">
                            <div v-if="item.category == 'photo'">
                                <a-button type="link" size="small"
                                    @click="download(item.file_path)">
                                    <a-icon type="file-image" theme="twoTone" two-tone-color="#3452eb" /> Download
                                </a-button><br>
                            </div>
                        </template>
                    </div>

                    <div slot="report" slot-scope="record">
                        <a-tooltip title="Upload File">
                            <a-button
                                size="small"
                                type="primary"
                                icon="upload"
                                 @click="showModalUpload('document', record.id)"
                            />
                        </a-tooltip>
                        <template v-for="item in record.files">
                            <div v-if="item.category == 'document'">
                                <a-button type="link" size="small"
                                    @click="download(item.file_path)">
                                    <a-icon type="file" theme="twoTone" two-tone-color="#3452eb" /> Download
                                </a-button><br>
                            </div>
                        </template>
                    </div>

                    <div slot="action" slot-scope="record">
                        <a-tooltip title="Edit Step">
                            <a-button
                                style="margin-left: 4px;"
                                size="small"
                                type="primary"
                                icon="edit"
                                @click="showModal(record.id)"
                                v-show="record.is_approved === false"
                            />
                        </a-tooltip>
                    </div>
                </a-table>
            </a-skeleton>

            <a-modal
                :visible="visible"
                :destroyOnClose="true"
                :footer="null"
                :closable="false"
            >
                <project-action-step-form
                    :items="items"
                    :hash="id"
                    :activity="items.steps.id"
                    @handleClose="closeModal"
                />
            </a-modal>

            <a-modal
                :visible="visibleUpload"
                :destroyOnClose="true"
                :footer="null"
                :closable="false"
            >
                <project-action-step-upload-form
                    :category="category"
                    :hash="id"
                    @handleClose="closeModalUpload"
                />
            </a-modal>
        </a-card>
    </div>
</template>

<script>
const progress = {
    not_done: 'Not Done',
    done: 'Done',
    progress: 'Progress'
}

const columns = [
    {
		key: 'step',
		title: 'Action Step',
        align: 'center',
		scopedSlots: {customRender: 'step'},
	}, {
		key: 'planning',
		title: 'Perencanaan',
		scopedSlots: {customRender: 'planning'},
        children: [
            {
                key: 'start',
                title: 'Mulai',
                align: 'center',
                scopedSlots: {customRender: 'start'},
            },
            {
                key: 'done',
                title: 'Selesai',
                align: 'center',
                scopedSlots: {customRender: 'done'},
            },
        ]
	}, {
		key: 'exe_date',
		title: 'Selesai Pelaksanaan',
        align: 'center',
		scopedSlots: {customRender: 'exe_date'},
	}, {
		key: 'gap',
		title: 'Gap',
        align: 'center',
		scopedSlots: {customRender: 'gap'}
	}, {
		key: 'progress',
        colSpan: 2,
		title: 'Progress Status',
        align: 'center',
		scopedSlots: {customRender: 'progress'}
	}, {
		key: 'percent',
        colSpan: 0,
		title: '',
        align: 'center',
		scopedSlots: {customRender: 'percent'}
	}, {
		key: 'pic',
		title: 'PIC',
        align: 'center',
		scopedSlots: {customRender: 'pic'}
	}, {
		key: 'issues',
		title: 'Issues',
		scopedSlots: {customRender: 'issues'},
        children: [
            {
                key: 'photo',
                title: 'Foto',
                align: 'center',
                scopedSlots: {customRender: 'photo'},
            },
            {
                key: 'report',
                title: 'Laporan',
                align: 'center',
                scopedSlots: {customRender: 'report'},
            },
        ]
	}, {
		key: 'action',
		title: 'Action',
        align: 'center',
		scopedSlots: {customRender: 'action'}
	},
]

export default {
    data() {
        return {
            progress,
            columns,
            form: this.$form.createForm(this),
            loading: false,
            visible: false,
            visibleUpload: false,
            processing: false,
            id: '',
            category: '',
            items: {},
            data: [],
            proposalRevision: false
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault()

            this.getItems()
        },
        handleReset(e) {
            e.preventDefault()
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current
            this.pushState(this.filters)
            this.getItems()
        },
        getItems() {
            this.loading = true

            let params = {
                outline: 'project_evaluation'
            }

            this.$http
                .get(this.routeUri('api.project-management.action-step.index')+ '?' + this.$qs.stringify(params))
                .then(response => {
                    this.items = response.data
                    this.data = response.data.steps
                    this.proposalRevision = response.data.proposalRevision
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        showModal(id) {
            this.id = id
            this.visible = true
        },
        showModalUpload(category, id){
            this.category = category
            this.id = id
            this.visibleUpload = true
        },
        closeModal(isRefresh) {
            this.visible = false

            if (isRefresh == true) {
                this.getItems()
            }
        },
        closeModalUpload(isRefresh) {
            this.visibleUpload = false

            if (isRefresh == true) {
                this.getItems()
            }
        },
        add(){

        },
        download(url) {
            window.open(url, '_blank')
        },
        prgColor(progress) {
            switch(progress){
                case 0:
                    return 'red;color: white'
                case 100:
                    return 'green;color: white'
                default: return 'yellow'
            }
        }
    },
}
</script>
